<template>
 <div >

                <div class="row col-sm-12">
                  
                  <div class="col-sm-12">
                  
                     <button
                        class="btn btn-primary ml-4 mb-2"
                        data-toggle="modal"
                        data-id="0"
                        data-target="#modal-add-useripblack"
                        ><plus-icon size="1.5x" class="custom-class"></plus-icon>Add</button>&nbsp;

                     <button
                        class="btn btn-primary ml-4 mb-2"
                        data-toggle="modal"
                        data-id="0"
                        data-target="#modal-update-useripblack"
                        ><plus-icon size="1.5x" class="custom-class"></plus-icon>Update</button>&nbsp;
                   
                  </div>
              

                </div>

                <div class="">
  <div class="row" style="overflow-x: auto;white-space: nowrap;">
      <div class="row col-12">
      <b-col lg="6" class="">
        <b-form-group
          label="Filter"
          label-cols-sm="3"
          label-align-sm="right"
          label-size="sm"
          label-for="filterInput"
          class="mb-0"
        >
          <b-input-group size="sm">
            <b-form-input
              v-model="filter"
              type="search"
              id="filterInput"
              placeholder="Type to Search"
            ></b-form-input>
            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
            </b-input-group-append>
          </b-input-group>

        </b-form-group>
      </b-col>

        <b-col sm="3" md="6" class="my-1">
      
      </b-col>
    </div>

    
                      <b-table
                      bordered=true
                      dark=true
                
                      show-empty

                      selectable
                      select-mode="single"
                      selected-variant="primary"
                      :items="mydatas"
                      :fields="fields"
                      :current-page="currentPage"
                      :per-page="perPage"
                      :filter="filter"
                      :filterIncludedFields="filterOn"
                      :sort-by.sync="sortBy"
                      :sort-desc.sync="sortDesc"
                      :sort-direction="sortDirection"
                      @filtered="onFiltered"
                      @row-selected="onRowSelectedMember"
                     
                    >
                      
                       <template v-slot:cell(created)="data">
                        {{ moment(data.value).format("YYYY-MM-DD HH:mm:ss") }} 
                      </template>
                      
                    </b-table>


                     <div class="row col-6">
    

      <b-col sm="7" md="6" class="my-1">
        <b-pagination
          v-model="currentPage"
          :total-rows="mydatas.length"
          per-page="10"
          align="fill"
          size="sm"
          class="my-0"
        ></b-pagination>
      </b-col>
    </div>
                  </div>          
       
                </div>

                 <div class="row mt-3" style="overflow-x: auto; white-space: nowrap;">
      
                </div>
 <div ref="modal-add-ipblack" id="modal-add-useripblack" class="modal fade" data-backdrop="true">
      <div class="modal-dialog modal-right m-right-input" >
        <div class="modal-content h-100 no-radius bg-dark">
          <div class="modal-header ">
            <div class="modal-title text-md row">Add IP Black List</div>
            
            <button class="close" data-dismiss="modal">&times;</button>
          </div>
          <div class="modal-body">
            <div class="p-3 row">

              <div class="col col-12">
                <div class="card">
                  <div class="card-header">IP Black List</div>
                  <div class="card-body">
                  <div class="form-group">
                      <label for="ip_username">Username</label>
                      <input v-model="ipblack_username" type="text" class="form-control" placeholder="Username" maxlength="100" id="ipblack_username" readonly>
                  </div>
                  <div class="form-group">
                      <label for="ip_ipaddress">IP</label>
                      <input v-model="ipblack_ipaddress" type="text" class="form-control" placeholder="IP Address" maxlength="100" id="ipblack_ipaddress">
                  </div>
                  </div>
                </div>
              </div>
             

          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-light" data-dismiss="modal">Cancel</button>
          <button  @click="saveipwhite(ipblack_username,ipblack_ipaddress)" type="button" class="btn btn-primary">Post</button>


        </div>
      </div>
      <!-- /.modal-content -->
    </div>
  </div>


   <div ref="modal-add-ipblack" id="modal-update-useripblack" class="modal fade" data-backdrop="true">
      <div class="modal-dialog modal-right m-right-input" >
        <div class="modal-content h-100 no-radius bg-dark">
          <div class="modal-header ">
            <div class="modal-title text-md row">Edit IP Black List</div>
            
            <button class="close" data-dismiss="modal">&times;</button>
          </div>
          <div class="modal-body">
            <div class="p-3 row">

              <div class="col col-12">
                <div class="card">
                  <div class="card-header">IP Black List</div>
                  <div class="card-body">
                  <div class="form-group">
                      <label for="ip_edit_username">Username</label>
                      <input v-model="selectrows.username" type="text" class="form-control" placeholder="Username" maxlength="100" id="ip_edit_username" readonly>
                  </div>
                  <div class="form-group">
                      <label for="ip_edit_ipaddress">IP</label>
                      <input v-model="selectrows.ip_address" type="text" class="form-control" placeholder="IP Address" maxlength="100" id="ip_edit_ipaddress">
                  </div>
                  </div>
                </div>
              </div>
             

          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-light" data-dismiss="modal">Cancel</button>
          <button  @click="saveeditipwhite(selectrows.username,selectrows.ip_address,selectrows.ip_id)" type="button" class="btn btn-primary">Post</button>


        </div>
      </div>
      <!-- /.modal-content -->
    </div>
  </div>

</div>


</template>

<script>


import { mapGetters } from "vuex";
import * as TYPES from "@/store/mutation-types";
import { DataTable,ItemsPerPageDropdown, Pagination  } from 'v-datatable-light'
import Spinner from "vue-simple-spinner";
import api from '@/api'
import Vue from 'vue'
import moment from 'moment'


export default {
  name: "useripblack",
 /* data : {
    dataTable:null,
    dataTableAnak:null,
    btngen:null,

  },*/

  data: function() {
    return {
        mydatas : [],
        dataTableList:null,
        indukdatas : [],
        selectrows : [],
        fields: [
          { key : 'username', label : 'Agent Name', sortable: true},
          { key: 'ip_address', label: 'IP Address', sortable: true,  },
          { key: 'created', label: 'Update Time', sortable: true},
        ],
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 15],
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
    }
  },
  components: {
    DataTable,
    ItemsPerPageDropdown,
    Pagination,
    Spinner
  },
  props: {
     showname : String,
     usid : String,
     usname : String
  },
  computed: {
   ...mapGetters(["allAgentAmountReports","singleUser"]),
   getAllReports(){
      return this.allAgentAmountReports
   },
   getUser(){
      return this.singleUser
   }
  },

  methods : {
    getreport(usid=''){
      let defuser = this.getUser
      let theid = ''
      if (usid == ''){
        theid = defuser.user_id;
      } else {
        theid = usid;
      }

       let par = {
           id : theid
        }

        this.$store.dispatch(TYPES.FETCH_AGENTAMOUNTREPORT, par)
        //debugger;
    },
     moment: function (thedate="") {
    return moment(thedate);
  },
   onRowSelectedMember(items) {
          this.editrow(items[0].username,items[0].ip_address,items[0].created,items[0].iplist_id)
      },
    editrow(usname,ip_address,uptgl,ip_id){
      this.selectrows = [];
        let myrow = {
          username : usname,
          ip_address : ip_address,
          updated : uptgl,
          ip_id : ip_id
        };
        this.selectrows = myrow;
         var table = document.getElementById("idlistblackuser");
        var  x = table.rows.length;

        for (var i=1;i<=x-1;i++) {
          var row = table.rows[i];
          var theid = row.id;
         // debugger;
        if (theid != ""){
          document.getElementById(theid).classList.remove("bg-primary");
        }
        }
        var element = document.getElementById('user-'+ip_id);
        //debugger;
        element.classList.add("bg-primary");
    },
    formatPrice(value) {
        let val = (value/1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    },
    saveipwhite(userid="",ipwhite=""){
      if (userid != "" && ipwhite != ""){
        let agent = {
          username : userid,
          ip_address :  ipwhite,
          status : 0
        };
       
         this.$store.dispatch(TYPES.CREATE_IPLIST, agent).then(res => {
          
        //  debugger;
          if(res.message == "Add IP Success"){
            this.$bvToast.toast(`Data has been saved successfully...`, {
              title: `Data Saved `,
              variant: 'info',
              toaster: 'b-toaster-top-center',
              solid: true
            })
            this.ip_username = "";
            this.ip_ipaddress = "";
            $('#modal-add-ipblack').modal('hide');
            this.showreportotabel();
            
          } else {
         //   debugger;
            this.$bvToast.toast(res.body.message, {
              title: `Data Error `,
              variant: 'warning',
              toaster: 'b-toaster-top-center',
              solid: true
            })
          }
        })
      } else {
         this.$bvToast.toast("Please fill the Username and Ip Address column", {
              title: `Data Error `,
              variant: 'warning',
              toaster: 'b-toaster-top-center',
              solid: true
            })
      }
    },
    saveeditipwhite(userid="",ipwhite="",ipid=""){
      if (userid != "" && ipwhite != ""){
        if (ipid != ""){
        let agent = {
          username : userid,
          ip_address :  ipwhite,
          iplist_id : ipid,
          status : 0
        };

       // debugger;
       
         this.$store.dispatch(TYPES.UPDATE_IPLIST, agent).then(res => {
          
          
          if(res.message == "update IP Success"){
            this.$bvToast.toast(`Data has been saved successfully...`, {
              title: `Data Saved `,
              variant: 'info',
              toaster: 'b-toaster-top-center',
              solid: true
            })
            this.selectrows.username = "";
            this.selectrows.ip_address = "";
           // this.ip_ipaddress = "";
            $('#modal-update-ipblack').modal('hide');
            this.showreportotabel();
            
          } else {
         //   debugger;
            this.$bvToast.toast(res.body.message, {
              title: `Data Error `,
              variant: 'warning',
              toaster: 'b-toaster-top-center',
              solid: true
            })
          }
        })
        } else {
            this.$bvToast.toast("Please select ip address that will be deleted", {
              title: `Data Error `,
              variant: 'warning',
              toaster: 'b-toaster-top-center',
              solid: true
            })
        }
      } else {
           this.$bvToast.toast("Please select ip address that will be deleted", {
              title: `Data Error `,
              variant: 'warning',
              toaster: 'b-toaster-top-center',
              solid: true
            })
      }
    },
    showreportotabel(usid=''){
   
   let defuser = this.getUser
   let theid = ''
   if (usid == ''){
        theid = defuser.user_id;
      } else {
        theid = usid;
      }


     api.get('user/iplist?user_id='+theid).then(({ data }) => {


      var thearr = data.data;
    
      this.mydatas = [];
      this.indukdatas = [];

      //this.indukdatas.push(thearr)
      
      if (thearr){
          

      
          for (var i = thearr.length - 1; i >= 0; i--) {
           if (thearr[i].status == '0'){
              this.mydatas.push(thearr[i]);
           }

          }
        
      }
     // debugger;
     
    })
  }
  },
  created(){
   /* let defuser = this.getUser
    let par = {
           id : defuser.user_id
        }

    this.$store.dispatch(TYPES.FETCH_AGENTAMOUNTREPORT, par)*/
  },
  mounted(){
  //  this.dataTable = $('#tableinduk').DataTable({}); 
    this.dataTableList = $(this.$refs.iplistblackuser).DataTable({});
    setTimeout(() => this.mydatas = fakeData(50), 1000);
    this.ipblack_username = this.usname;

    this.showreportotabel(this.usid);
   // this.dataTableAnak = $('#tabelanak').DataTable({}); 
   // this.showreportotabel();

  /*  this,dataTable.on("draw.dt", function(){
      $(".edit-placeholder").each(function(i, el){
          const data = table.api().cell( $(this).closest("td") ).data();
          new Edit({data:{data}}).$mount(el)
      })
    })*/

  },
  watch: {
  mydatas(val) {
    this.dataTableList.destroy();
    this.$nextTick(() => {
      this.dataTableList = $(this.$refs.iplistblackuser).DataTable()
    });
  }
},
};

</script>